import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { isGamesTheme } from "@utils";
import { isLoginFlow } from "@utils/membership/membershipUtils";
import { useRootAppStore } from "@hooks";
import { Clock, Language } from "@components-shared/desktop";
import {
	HeaderLogo,
	HeaderSearch,
	HeaderUserDetails,
	HeaderThemeToggle,
	HeaderSpecialLinks,
	HeaderNavigation,
} from "./components";
import { useAppContext } from "@state/hooks/shared";
import ScrollDirectionContext from "@state/context/scroll/ScrollDirectionContext";
import CasinoHeaderSearch from "./components/CasinoHeaderSearch";

export default function Header() {
	const { culture } = useAppContext();
	const { pathname } = useLocation();
	const isHeaderWithoutActions = useMemo(
		() => isLoginFlow(pathname) || pathname === `/${culture}/restrict`,
		[pathname, culture]
	);
	const scrollDirection = useContext(ScrollDirectionContext);
	const rootStore = useRootAppStore();
	const accountActivationStore =
		rootStore.userAuthStore.accountActivationStore;

	if (
		accountActivationStore.isAccountActivationCongratulationsActive ||
		accountActivationStore.accountActivationError
	) {
		return null;
	}

	if (isHeaderWithoutActions) {
		return (
			<header className={"l--header is-" + scrollDirection}>
				<div className={"header is-" + scrollDirection}>
					<div className="header__top">
						<Clock />

						<div className="header__settings">
							<Language rounded />
							<HeaderThemeToggle />
							<div id="lockSuccessContainer" />
						</div>
					</div>

					<div className="header__main">
						<div className="header__col header__col--left">
							<HeaderLogo />
							<HeaderSpecialLinks />
						</div>
					</div>
				</div>
			</header>
		);
	}

	return (
		<header className={"l--header is-" + scrollDirection}>
			<div className={"header is-" + scrollDirection}>
				<div className="header__top">
					<Clock />

					<div className="header__settings">
						{!isGamesTheme() && <HeaderSearch />}
						<CasinoHeaderSearch />

						<Language rounded />
						<HeaderThemeToggle />
					</div>
				</div>

				<div className="header__main">
					<div className="header__col header__col--left">
						<HeaderLogo />
						<HeaderSpecialLinks />
					</div>

					<div className="header__col header__col--grow">
						<HeaderNavigation />
					</div>

					<div className="header__col header__col--right">
						<HeaderUserDetails />
					</div>
				</div>
			</div>
		</header>
	);
}
